export default "__VITE_ASSET__712fd12c__"